/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2023-12-04 14:53:46
 * @LastEditors: Junteng Shi
 * @LastEditTime: 2025-11-26 09:10:27
 */
// 权限问题后期增加
// import axios from 'axios';
import request, { get, post } from '@/utils/http/axios/index';
import qs from 'qs';

export interface LoginData {
  username: string;
  password: string;
  captcha: string;
  uuid: string;
  grant_type: string;
  validateCaptcha: boolean | string;
  captchaToken: string
}

enum URL {
  changePW = '/pbl/common/change-password',
}

export const changePassword = async (params) =>
  post({
    url: URL.changePW,
    data: params,
    // headers: {
    //   //头部参数
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
  });
/**
 * 系统登录
 */
export function logins(data: LoginData) {
  return request({
    url: `/pbl/oauth/token`,
    method: 'post',
    data,
    headers: {
      Authorization: 'Basic cmVucmVuaW86cmVucmVuaW8=',
      // Authorization: "Basic d2N5X2FpOndjeV9haQ==",
      ContentType: 'application/x-www-form-urlencoded',
    },
    transformRequest: [(data) => qs.stringify(data)],
  });
}
/**
 * 系统退出
 */
export function logout() {
  return request({
    url: '/pbl/oauth/logout',
    method: 'post',
  });
}
/**
 * 获取用户信息
 */
export function getUserProfile() {
  return request({
    url: `/pbl/common/getUserInfo`,
    method: 'get',
  });
}

/**
 * 获取菜单
 */
export function getSysMenusList() {
  return request({
    url: `/pbl/menu/getMenu`,
    method: 'get',
    // params: { system: 4 }, // 考务 0 抽签1 监考2 教学 3 实验室管理平台4
  });
}
